import { render, staticRenderFns } from "./ResumenDeudores.vue?vue&type=template&id=ffc432c8&scoped=true"
import script from "./ResumenDeudores.vue?vue&type=script&lang=js"
export * from "./ResumenDeudores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc432c8",
  null
  
)

export default component.exports